import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = ["You spend too much time on 'low-impact' areas that guests never actually notice.", "You don't have a 'laundry anchor,' leaving you waiting for the dryer while the guest is in the driveway.", "You clean 'rooms' instead of 'paths,' causing you to backtrack and dirty the floors you just mopped.", "You use generic cleaners that require 'elbow grease' instead of industrial-speed chemicals that do the work for you."];
export function WhyFailed() {
  return <section className="bg-brand-darker py-24 text-white" data-id="element-175">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-4xl sm:text-5xl text-white mb-4" data-id="element-178">
            WHY WHAT YOU TRIED <span className="text-red-500" data-id="element-179">DIDN'T WORK</span>
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto" data-id="element-180"></div>
        </div>

        <div className="space-y-6" data-id="element-181">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-182">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-183" />
              <p className="text-lg sm:text-xl text-gray-300 font-medium leading-relaxed" data-id="element-184">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}